/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var initialState = {
  activeView: 0,
  currentCategoryId: '',
  fullScreen: false,
  lastSelectedAttribute: '',
  lastSelectedProperty: '',
  modalData: {},
  modalOpen: false,
  modalType: '',
  shouldScrollToCategory: false
};

var sessionReducer = function sessionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var assign = function assign(update) {
    return Object.assign({}, state, update);
  };

  switch (action.type) {
    case constants_1.UI.CURRENT_CATEGORY:
      {
        var currentCategoryId = action.currentCategoryId,
            shouldScrollToCategory = action.shouldScrollToCategory;
        return Object.assign({}, state, {
          currentCategoryId: currentCategoryId,
          shouldScrollToCategory: shouldScrollToCategory
        });
      }

    case constants_1.UI.CLOSE_MODAL:
      {
        return Object.assign({}, state, {
          modalOpen: false
        });
      }

    case constants_1.UI.LAST_SELECTION:
      {
        var selection = action.selection;
        return assign({
          lastSelectedAttribute: Object.keys(selection)[0],
          lastSelectedProperty: Object.values(selection)[0]
        });
      }

    case constants_1.UI.OPEN_MODAL:
      {
        var modalData = action.modalData,
            modalType = action.modalType;
        return Object.assign({}, state, {
          modalOpen: true,
          modalData: modalData,
          modalType: modalType
        });
      }

    case constants_1.UI.SET_ACTIVE_VIEW:
      {
        var activeView = action.activeView;
        return Object.assign({}, state, {
          activeView: activeView
        });
      }

    case constants_1.UI.SET_FULL_SCREEN:
      {
        var fullScreen = action.fullScreen;
        return Object.assign({}, state, {
          fullScreen: fullScreen
        });
      }

    default:
      return state;
  }
};

exports.default = sessionReducer;